import { useTranslation } from "react-i18next";
import {
  useAddCoordinatorMutation,
  useRemoveCoordinatorMutation,
  useCoordinatorsQuery,
} from "../Teams.state";
import { CardBody } from "../../App.styles";
import TeamSelect from "../TeamSelect";
import Spinner from "../../common/Spinner";
const Coordinators = () => {
  const { t } = useTranslation();
  const { data: coordinators, isFetching } = useCoordinatorsQuery();
  const { addCoordinator } = useAddCoordinatorMutation();
  const { removeCoordinator } = useRemoveCoordinatorMutation();

  const handleChange = async (value) => {
    for (let player of value.filter(
      (v) => !coordinators.find((c) => c.id === v.id)
    )) {
      await addCoordinator(player);
    }

    for (let player of coordinators.filter(
      (c) => !value.find((v) => c.id === v.id)
    )) {
      await removeCoordinator(player);
    }
  };

  return (
    <CardBody className="card">
      <div className="card-header bg-dark text-light">
        <span className="card-title">{t('Coordinators')}</span>
      </div>
      <div className="card-body">
        <p dangerouslySetInnerHTML={{__html: t(`Want someone else to coordinate the event? Add them here to give them
          light weight administrative access.`)}} />
        {
          isFetching
          ? <Spinner size="0.875rem" />
          : (
            <TeamSelect
              setValue={handleChange}
              value={coordinators}
              mapLabel="email"
              placeholder={t("Select people...")}
            />
          )
        }
      </div>
    </CardBody>
  );
};

export default Coordinators;
